<script  module>
  import AppLayout from '$lib/layouts/AppLayout.svelte'
  export const layout = AppLayout
  layout.title = "aaaa"
</script>

<script lang="ts">
  import { router, usePage } from "@inertiajs/svelte";
  import { toast } from "svelte-sonner";
  import { 
    Save, 
    Code2, 
    ArrowLeft, 
    Sparkles, 
    Copy 
  } from "lucide-svelte";

  let { site_id, current_site = { name: "" }, config_data, t = {} as any } = $props();
  const page = usePage();

  const domainSuffix = $derived(page.props.frontend_domain_suffix);

  let jsonRaw = $state(JSON.stringify(config_data, null, 2));
  let isDirty = $state(false);

  // 格式化 JSON
  function formatJson() {
    try {
      const obj = JSON.parse(jsonRaw);
      jsonRaw = JSON.stringify(obj, null, 2);
      toast.info(t.validation?.json_beautified);
    } catch (e) {
      toast.error(t.validation?.json_invalid_format);
    }
  }

  // 提交配置数据
  function handleSubmit() {
    try {
      const parsed = JSON.parse(jsonRaw);
      
      if (!parsed.subdomain?.trim()) {
        toast.error(t.validation?.subdomain_required);
        return;
      }

      const url = site_id ? `/sites/${site_id}` : '/sites';
      const method = site_id ? 'patch' : 'post';

      router[method](url, { config_raw: jsonRaw }, {
        onBefore: () => toast.loading("Syncing Schema...", { id: "save-site" }),
        onSuccess: () => {
          isDirty = false;
        },
        onError: (errors) => {
          const msg = Object.values(errors).join(", ") || "Failed to save schema";
          toast.error(msg, { id: "save-site" });
        }
      });
    } catch (e) {
      toast.error(t.validation?.json_syntax_error);
    }
  }

  function handleInput() {
    isDirty = true;
  }
</script>

<svelte:head>
  <title>aaaa</title>
</svelte:head>
<div class="flex flex-col h-screen bg-background">
  <header class="h-16 border-b flex items-center justify-between px-6 bg-card/50 backdrop-blur-md">
    <div class="flex items-center gap-4">
      <button 
        onclick={() => router.get('/sites')} 
        class="p-2 hover:bg-accent rounded-full transition-colors"
      >
        <ArrowLeft class="size-5" />
      </button>
      <div>
        <h1 class="text-sm font-bold flex items-center gap-2">
          <Code2 class="size-4 text-primary" />
          {site_id ? t.editor_title_edit : t.editor_title_new}
        </h1>
        {#if isDirty}
          <span class="text-[10px] text-orange-500 font-medium animate-pulse">{t.dirty_changes}</span>
        {:else if current_site?.name}
          <span class="text-[10px] text-muted-foreground uppercase tracking-widest">{current_site.name}</span>
        {/if}
      </div>
    </div>

    <div class="flex items-center gap-3">
      <button 
        onclick={formatJson}
        class="flex items-center gap-2 px-3 py-1.5 text-xs font-medium hover:bg-accent rounded-md transition-all"
      >
        <Sparkles class="size-3" />
        {t.beautify}
      </button>
      
      <button 
        onclick={handleSubmit}
        class="flex items-center gap-2 px-6 py-1.5 text-xs font-bold bg-primary text-primary-foreground hover:bg-primary/90 rounded-md shadow-lg shadow-primary/20 transition-all"
      >
        <Save class="size-3" />
        {site_id ? t.btn_save_blueprint : t.btn_create_blueprint}
      </button>
    </div>
  </header>

  <main class="flex-1 overflow-hidden flex flex-col p-4 bg-slate-50 dark:bg-slate-950">
    <div class="relative flex-1 group">
      <div class="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent pointer-events-none"></div>
      
      <textarea
        bind:value={jsonRaw}
        oninput={handleInput}
        class="w-full h-full p-8 font-mono text-sm leading-relaxed
               bg-slate-900 text-blue-100 border-none rounded-xl shadow-2xl
               focus:ring-2 focus:ring-primary/50 outline-none resize-none
               transition-all scrollbar-thin scrollbar-thumb-primary/20"
        spellcheck="false"
      ></textarea>

      <div class="absolute bottom-6 right-6 flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
        <button 
          onclick={() => { navigator.clipboard.writeText(jsonRaw); toast.success(t.copied); }}
          class="p-2 bg-white/10 hover:bg-white/20 backdrop-blur-md rounded-lg text-white"
        >
          <Copy class="size-4" />
        </button>
      </div>
    </div>

    <footer class="mt-4 flex items-center justify-between text-[10px] text-muted-foreground px-2">
      <div class="flex gap-4">
        <span>CHARACTERS: {jsonRaw.length}</span>
        <span>LINES: {jsonRaw.split('\n').length}</span>
      </div>
      <div class="flex gap-2 items-center">
        <div class="size-1.5 rounded-full bg-green-500"></div>
        <span>{t.validation_ready}</span>
      </div>
    </footer>
  </main>
</div>

<style>
  textarea::-webkit-scrollbar {
    width: 8px;
  }
  textarea::-webkit-scrollbar-thumb {
    background: rgba(59, 130, 246, 0.1);
    border-radius: 4px;
  }
  textarea::-webkit-scrollbar-thumb:hover {
    background: rgba(59, 130, 246, 0.3);
  }
</style>